export const GET_WORKSHOP_SEGMENTS = "GET_WORKSHOP_SEGMENTS";
export const GET_WORKSHOP_SEGMENTS_SUCCESS = "GET_WORKSHOP_SEGMENTS_SUCCESS";
export const GET_WORKSHOP_SEGMENTS_FAILED = "GET_WORKSHOP_SEGMENTS_FAILED";

export const GET_VEHICLE_PERSPECTIVES = "GET_VEHICLE_PERSPECTIVES";
export const GET_VEHICLE_PERSPECTIVES_SUCCESS = "GET_VEHICLE_PERSPECTIVES_SUCCESS";
export const GET_VEHICLE_PERSPECTIVES_FAILED = "GET_VEHICLE_PERSPECTIVES_FAILED";

export const GET_DAMAGE_TYPES = "GET_DAMAGE_TYPES";
export const GET_DAMAGE_TYPES_SUCCESS = "GET_DAMAGE_TYPES_SUCCESS";
export const GET_DAMAGE_TYPES_FAILED = "GET_DAMAGE_TYPES_FAILED";

export const GET_BODY_DAMAGE_TYPES = "GET_BODY_DAMAGE_TYPES";
export const GET_BODY_DAMAGE_TYPES_SUCCESS = "GET_BODY_DAMAGE_TYPES_SUCCESS";
export const GET_BODY_DAMAGE_TYPES_FAILED = "GET_BODY_DAMAGE_TYPES_FAILED";

export const CLEAR_DAMAGE_TYPES = "CLEAR_DAMAGE_TYPES";

export const CLEAR_BODY_DAMAGE_TYPES_SUCCESS = "CLEAR_BODY_DAMAGE_TYPES_SUCCESS";

export const SAVE_SELECTED_PART_ID = "SAVE_SELECTED_PART_ID";

export const SAVE_ORIENTATION = "SAVE_ORIENTATION";

export const GET_GLOBAL_SETTINGS = "GET_GLOBAL_SETTINGS";
export const GET_GLOBAL_SETTINGS_SUCCESS = "GET_GLOBAL_SETTINGS_SUCCESS";
export const GET_GLOBAL_SETTINGS_FAILED = "GET_GLOBAL_SETTINGS_FAILED";

export const GET_LIST_OF_WORKSHOPS = "GET_LIST_OF_WORKSHOPS";
export const GET_LIST_OF_WORKSHOPS_SUCCESS = "GET_LIST_OF_WORKSHOPS_SUCCESS";
export const GET_LIST_OF_WORKSHOPS_FAILED = "GET_LIST_OF_WORKSHOPS_FAILED";

export const GET_WORKSHOP_DISTANCE = "GET_WORKSHOP_DISTANCE";
export const GET_WORKSHOPS_DISTANCE_SUCCESS = "GET_WORKSHOP_DISTANCE_SUCCESS";
export const GET_WORKSHOPS_DISTANCE_FAILED = "GET_WORKSHOP_DISTANCE_FAILED";